export default "__VITE_ASSET__XrMc$bIv__"